import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight, FaFingerprint } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import { GiCctvCamera, GiLockedDoor } from "react-icons/gi";
import { MdAddAlert } from "react-icons/md";
import { TbDeviceLandlinePhone } from "react-icons/tb";

export default function HomeBanner2(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-secondary"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				
				<div 
					className="container"
					
				>
					<div className="row">

						<div className="col-md-12">
							<h5 className="text-light font-bold text-center">FIMACY COMPANY LIMITED</h5>
							
							<h1
								style={{
									fontSize: "22px",
									paddingTop: "30px",
									paddingBottom: "30px"
								}}
								className="font-light text-center"
							>
								Fimacy Company Limited was found on March, 2019 and incorporated on 21st June, 2019 under a Certificate of Incorporation No. 139359380 issued in the United Republic of Tanzania under the Company's Act of year 2002. The company began as a small venture company supporting IT, Telecoms & Network solutions for clients with small and medium enterprises based on client server environment. With a long term commitment to IT, Telecoms & Network industry, we have successfully established ourselves as a qualified and professional company which specializes in providing Infrastructure technical services and solutions including High Availability solutions, Security solutions, Internetworking &network infrastructure design, supporting Microsoft deployed solutions and IT based security.
								<br/><br/>
								Fimacy Company Limited prides in its founders and workforce who comprise highly skilled and well experienced University graduates of Tanzanian origin. These young professionals have excelled in their various fields of expertise and are geared to deliver up to standard services with keen attention to quality.
							</h1>

						</div>


						

						
					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
